import EmailTemplatePreview from "./EmailTemplatePreview"

export default EmailTemplatePreview
